// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { CreateAdminAssessmentQuestionData, CreateAdminAssessmentQuestionResponses, CreateAdminAssessmentQuestionSetData, CreateAdminAssessmentQuestionSetResponses, CreateAdminCommentData, CreateAdminCommentResponses, DeleteAdminCommentData, DeleteAdminCommentResponses, DeleteApiV1GroupsByGroupIdTodoItemsByTodoItemIdData, DeleteApiV1GroupsByGroupIdTodoItemsByTodoItemIdErrors, DeleteApiV1GroupsByGroupIdTodoItemsByTodoItemIdResponses, DeleteApiV1GroupsByGroupIdTodoListsByIdData, DeleteApiV1GroupsByGroupIdTodoListsByIdErrors, DeleteApiV1GroupsByGroupIdTodoListsByIdResponses, DeleteApiV1UsersSignOutData, DeleteApiV1UsersSignOutErrors, DeleteApiV1UsersSignOutResponses, DeleteBulkAdminAssessmentQuestionsData, DeleteBulkAdminAssessmentQuestionsResponses, ForkAdminAssessmentQuestionData, ForkAdminAssessmentQuestionResponses, GetAdminAssessmentQuestionData, GetAdminAssessmentQuestionErrors, GetAdminAssessmentQuestionResponses, GetAdminAssessmentQuestionsData, GetAdminAssessmentQuestionsErrors, GetAdminAssessmentQuestionSetsData, GetAdminAssessmentQuestionSetsErrors, GetAdminAssessmentQuestionSetsResponses, GetAdminAssessmentQuestionsResponses, GetAdminAssessmentStatisticsData, GetAdminAssessmentStatisticsErrors, GetAdminAssessmentStatisticsResponses, GetAdminCommentData, GetAdminCommentErrors, GetAdminCommentResponses, GetAdminCommentsData, GetAdminCommentsErrors, GetAdminCommentsResponses, GetAdminDocumentData, GetAdminDocumentErrors, GetAdminDocumentResponses, GetAdminDocumentsData, GetAdminDocumentsErrors, GetAdminDocumentsResponses, GetAdminGroupData, GetAdminGroupErrors, GetAdminGroupResponses, GetAdminGroupsData, GetAdminGroupsErrors, GetAdminGroupsResponses, GetAdminInitDataData, GetAdminInitDataErrors, GetAdminInitDataResponses, GetAdminLearningObjectiveData, GetAdminLearningObjectiveErrors, GetAdminLearningObjectiveResponses, GetAdminLearningObjectivesData, GetAdminLearningObjectivesErrors, GetAdminLearningObjectivesResponses, GetAdminProjectsData, GetAdminProjectsErrors, GetAdminProjectsResponses, GetAdminQuizData, GetAdminQuizErrors, GetAdminQuizItemData, GetAdminQuizItemErrors, GetAdminQuizItemResponseData, GetAdminQuizItemResponseErrors, GetAdminQuizItemResponseResponses, GetAdminQuizItemResponses, GetAdminQuizItemResponsesData, GetAdminQuizItemResponsesErrors, GetAdminQuizItemResponsesResponses, GetAdminQuizItemsData, GetAdminQuizItemsErrors, GetAdminQuizItemsResponses, GetAdminQuizResponses, GetAdminQuizzesData, GetAdminQuizzesErrors, GetAdminQuizzesResponses, GetAdminReusableObjectData, GetAdminReusableObjectErrors, GetAdminReusableObjectResponses, GetAdminReusableObjectsData, GetAdminReusableObjectsErrors, GetAdminReusableObjectsResponses, GetAdminSaqResponseData, GetAdminSaqResponseErrors, GetAdminSaqResponseResponses, GetAdminSaqResponsesData, GetAdminSaqResponsesErrors, GetAdminSaqResponsesResponses, GetAdminUserData, GetAdminUserErrors, GetAdminUserResponses, GetAdminUsersData, GetAdminUsersErrors, GetAdminUsersResponses, GetAdminVersionsData, GetAdminVersionsErrors, GetAdminVersionsResponses, GetApiV1EventsData, GetApiV1EventsResponses, GetApiV1GroupsByGroupIdCardsData, GetApiV1GroupsByGroupIdCardsResponses, GetApiV1GroupsByGroupIdDashboardsStudentCalibrateSummaryData, GetApiV1GroupsByGroupIdDashboardsStudentCalibrateSummaryErrors, GetApiV1GroupsByGroupIdDashboardsStudentCalibrateSummaryResponses, GetApiV1GroupsByGroupIdDashboardsStudentCaseLearningTimeData, GetApiV1GroupsByGroupIdDashboardsStudentCaseLearningTimeErrors, GetApiV1GroupsByGroupIdDashboardsStudentCaseLearningTimeResponses, GetApiV1GroupsByGroupIdDashboardsStudentCompletedAvailableCasesData, GetApiV1GroupsByGroupIdDashboardsStudentCompletedAvailableCasesErrors, GetApiV1GroupsByGroupIdDashboardsStudentCompletedAvailableCasesResponses, GetApiV1GroupsByGroupIdDashboardsStudentCompletedWorkData, GetApiV1GroupsByGroupIdDashboardsStudentCompletedWorkErrors, GetApiV1GroupsByGroupIdDashboardsStudentCompletedWorkResponses, GetApiV1GroupsByGroupIdDashboardsStudentContentSummaryData, GetApiV1GroupsByGroupIdDashboardsStudentContentSummaryErrors, GetApiV1GroupsByGroupIdDashboardsStudentContentSummaryResponses, GetApiV1GroupsByGroupIdDashboardsStudentPerformanceSummaryData, GetApiV1GroupsByGroupIdDashboardsStudentPerformanceSummaryErrors, GetApiV1GroupsByGroupIdDashboardsStudentPerformanceSummaryResponses, GetApiV1GroupsByGroupIdDashboardsStudentProgressSummaryData, GetApiV1GroupsByGroupIdDashboardsStudentProgressSummaryErrors, GetApiV1GroupsByGroupIdDashboardsStudentProgressSummaryResponses, GetApiV1GroupsByGroupIdDocumentSetsByDocumentSetIdDocumentsData, GetApiV1GroupsByGroupIdDocumentSetsByDocumentSetIdDocumentsResponses, GetApiV1GroupsByGroupIdDocumentSetsByParentDocumentSetIdDocumentSetsData, GetApiV1GroupsByGroupIdDocumentSetsByParentDocumentSetIdDocumentSetsResponses, GetApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdData, GetApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdResponses, GetApiV1GroupsByGroupIdQuizItemResponsesByIdData, GetApiV1GroupsByGroupIdQuizItemResponsesByIdResponses, GetApiV1GroupsByGroupIdQuizItemResponsesData, GetApiV1GroupsByGroupIdQuizItemResponsesResponses, GetApiV1GroupsByGroupIdQuizzesByIdData, GetApiV1GroupsByGroupIdQuizzesByIdResponses, GetApiV1GroupsByGroupIdQuizzesData, GetApiV1GroupsByGroupIdQuizzesNewData, GetApiV1GroupsByGroupIdQuizzesNewResponses, GetApiV1GroupsByGroupIdQuizzesResponses, GetApiV1GroupsByGroupIdSaqResponsesByIdData, GetApiV1GroupsByGroupIdSaqResponsesByIdResponses, GetApiV1GroupsByGroupIdSaqResponsesData, GetApiV1GroupsByGroupIdSaqResponsesResponses, GetApiV1GroupsByGroupIdTodoItemsData, GetApiV1GroupsByGroupIdTodoItemsResponses, GetApiV1GroupsByGroupIdVariantsByIdData, GetApiV1GroupsByGroupIdVariantsByIdResponses, GetApiV1GroupsByIdCustomDocumentsData, GetApiV1GroupsByIdCustomDocumentsResponses, GetApiV1GroupsByIdData, GetApiV1GroupsByIdJoinOpenGroupsData, GetApiV1GroupsByIdJoinOpenGroupsResponses, GetApiV1GroupsByIdResponses, GetApiV1GroupsData, GetApiV1GroupsResponses, GetApiV1PublicGroupsData, GetApiV1PublicGroupsResponses, GetApiV1UpdatesData, GetApiV1UpdatesResponses, GetApiV3GroupsByGroupIdDocumentsByIdCreateOrUpdateTodoItemsData, GetApiV3GroupsByGroupIdDocumentsByIdCreateOrUpdateTodoItemsResponses, GetApiV3GroupsByGroupIdDocumentsByIdData, GetApiV3GroupsByGroupIdDocumentsByIdResponses, GetApiV3GroupsByGroupIdDocumentsData, GetApiV3GroupsByGroupIdDocumentsResponses, GetCommonUserData, GetCommonUserResponses, GetDocumentsForDocumentSetData, GetDocumentsForDocumentSetErrors, GetDocumentsForDocumentSetResponses, ImportAdminAssessmentQuestionsData, ImportAdminAssessmentQuestionsResponses, PatchApiV1GroupsByGroupIdCardsToggleData, PatchApiV1GroupsByGroupIdCardsToggleErrors, PatchApiV1GroupsByGroupIdCardsToggleResponses, PatchApiV1GroupsByGroupIdQuizItemResponsesByIdResetData, PatchApiV1GroupsByGroupIdQuizItemResponsesByIdResetResponses, PatchApiV1GroupsByGroupIdQuizzesByIdResetData, PatchApiV1GroupsByGroupIdSaqResponsesByIdToggleFlagData, PatchApiV1GroupsByGroupIdSaqResponsesByIdToggleFlagResponses, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkMoveData, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkMoveErrors, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkMoveResponses, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkResetData, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkResetErrors, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkResetResponses, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdData, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdErrors, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResetCaseData, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResetCaseErrors, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResetCaseResponses, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResponses, PatchApiV1UsersByIdData, PatchApiV1UsersByIdErrors, PatchApiV1UsersByIdResponses, PostApiV1GroupsByGroupIdDashboardsSubscriberAccessRequestData, PostApiV1GroupsByGroupIdDashboardsSubscriberAccessRequestErrors, PostApiV1GroupsByGroupIdDashboardsSubscriberAccessRequestResponses, PostApiV1GroupsByGroupIdQuizzesData, PostApiV1GroupsByGroupIdQuizzesErrors, PostApiV1GroupsByGroupIdQuizzesNumberOfItemsData, PostApiV1GroupsByGroupIdQuizzesNumberOfItemsResponses, PostApiV1GroupsByGroupIdQuizzesResponses, PostApiV1GroupsByGroupIdSaqResponsesByIdResetData, PostApiV1GroupsByGroupIdSaqResponsesByIdResetErrors, PostApiV1GroupsByGroupIdSaqResponsesByIdResetResponses, PostApiV1GroupsByGroupIdSaqResponsesCreateQuizData, PostApiV1GroupsByGroupIdSaqResponsesCreateQuizErrors, PostApiV1GroupsByGroupIdSaqResponsesCreateQuizResponses, PostApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkCreateOrUpdateData, PostApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkCreateOrUpdateErrors, PostApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkCreateOrUpdateResponses, PostApiV1GroupsByGroupIdTodoItemsData, PostApiV1GroupsByGroupIdTodoItemsErrors, PostApiV1GroupsByGroupIdTodoItemsResponses, PostApiV1GroupsByGroupIdTodoListsData, PostApiV1GroupsByGroupIdTodoListsResponses, PostApiV1GroupsMobileJsonData, PostApiV1GroupsMobileJsonResponses, PostApiV1UsersSignInData, PostApiV1UsersSignInErrors, PostApiV1UsersSignInResponses, PostApiV3GroupsByGroupIdDocumentsByIdCreateOrStartQuizData, PostApiV3GroupsByGroupIdDocumentsByIdCreateOrStartQuizResponses, PostWebhooksHubspotData, PostWebhooksHubspotErrors, PostWebhooksHubspotResponses, PutApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdData, PutApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdErrors, PutApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdResponses, PutApiV1GroupsByGroupIdQuizItemResponsesBulkUpdateData, PutApiV1GroupsByGroupIdQuizItemResponsesBulkUpdateResponses, PutApiV1GroupsByGroupIdQuizItemResponsesByIdData, PutApiV1GroupsByGroupIdQuizItemResponsesByIdResponses, ReceiveHubspotWebhookData, ReceiveHubspotWebhookErrors, ReceiveHubspotWebhookResponses, UpdateBulkAdminAssessmentQuestionsData, UpdateBulkAdminAssessmentQuestionsResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Receive HubSpot Webhook
 */
export const receiveHubspotWebhook = <ThrowOnError extends boolean = false>(options: Options<ReceiveHubspotWebhookData, ThrowOnError>): RequestResult<ReceiveHubspotWebhookResponses, ReceiveHubspotWebhookErrors, ThrowOnError> => (options.client ?? client).post<ReceiveHubspotWebhookResponses, ReceiveHubspotWebhookErrors, ThrowOnError>({
    url: '/webhooks/hubspot_signature_verification',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Handle HubSpot webhook events
 */
export const postWebhooksHubspot = <ThrowOnError extends boolean = false>(options: Options<PostWebhooksHubspotData, ThrowOnError>): RequestResult<PostWebhooksHubspotResponses, PostWebhooksHubspotErrors, ThrowOnError> => (options.client ?? client).post<PostWebhooksHubspotResponses, PostWebhooksHubspotErrors, ThrowOnError>({
    url: '/webhooks/hubspot',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * list assessment_question_sets
 *
 * Get assessment_question_sets list
 */
export const getAdminAssessmentQuestionSets = <ThrowOnError extends boolean = false>(options?: Options<GetAdminAssessmentQuestionSetsData, ThrowOnError>): RequestResult<GetAdminAssessmentQuestionSetsResponses, GetAdminAssessmentQuestionSetsErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminAssessmentQuestionSetsResponses, GetAdminAssessmentQuestionSetsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/assessment_question_sets',
    ...options
});

/**
 * create admin assessment question set
 *
 * Create admin assessment question set
 */
export const createAdminAssessmentQuestionSet = <ThrowOnError extends boolean = false>(options?: Options<CreateAdminAssessmentQuestionSetData, ThrowOnError>): RequestResult<CreateAdminAssessmentQuestionSetResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CreateAdminAssessmentQuestionSetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/assessment_question_sets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * list assessment_questions
 *
 * Get assessment_questions list
 */
export const getAdminAssessmentQuestions = <ThrowOnError extends boolean = false>(options?: Options<GetAdminAssessmentQuestionsData, ThrowOnError>): RequestResult<GetAdminAssessmentQuestionsResponses, GetAdminAssessmentQuestionsErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminAssessmentQuestionsResponses, GetAdminAssessmentQuestionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/assessment_questions',
    ...options
});

/**
 * create admin assessment question
 *
 * Create admin assessment question
 */
export const createAdminAssessmentQuestion = <ThrowOnError extends boolean = false>(options?: Options<CreateAdminAssessmentQuestionData, ThrowOnError>): RequestResult<CreateAdminAssessmentQuestionResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CreateAdminAssessmentQuestionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/assessment_questions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * update assessment_questions
 *
 * Update AssessmentQuestions
 */
export const updateBulkAdminAssessmentQuestions = <ThrowOnError extends boolean = false>(options?: Options<UpdateBulkAdminAssessmentQuestionsData, ThrowOnError>): RequestResult<UpdateBulkAdminAssessmentQuestionsResponses, unknown, ThrowOnError> => (options?.client ?? client).patch<UpdateBulkAdminAssessmentQuestionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/assessment_questions/update_bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * delete AssessmentQuestions
 *
 * Delete AssessmentQuestions
 */
export const deleteBulkAdminAssessmentQuestions = <ThrowOnError extends boolean = false>(options?: Options<DeleteBulkAdminAssessmentQuestionsData, ThrowOnError>): RequestResult<DeleteBulkAdminAssessmentQuestionsResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<DeleteBulkAdminAssessmentQuestionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/assessment_questions/delete_bulk',
    ...options
});

/**
 * show assessment_question
 *
 * Show assessment_question
 */
export const getAdminAssessmentQuestion = <ThrowOnError extends boolean = false>(options: Options<GetAdminAssessmentQuestionData, ThrowOnError>): RequestResult<GetAdminAssessmentQuestionResponses, GetAdminAssessmentQuestionErrors, ThrowOnError> => (options.client ?? client).get<GetAdminAssessmentQuestionResponses, GetAdminAssessmentQuestionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/assessment_questions/{id}',
    ...options
});

/**
 * import assessment questions
 *
 * Import assessment questions
 */
export const importAdminAssessmentQuestions = <ThrowOnError extends boolean = false>(options?: Options<ImportAdminAssessmentQuestionsData, ThrowOnError>): RequestResult<ImportAdminAssessmentQuestionsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ImportAdminAssessmentQuestionsResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/assessment_questions/import',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * fork assessment question
 *
 * Fork assessment question
 */
export const forkAdminAssessmentQuestion = <ThrowOnError extends boolean = false>(options: Options<ForkAdminAssessmentQuestionData, ThrowOnError>): RequestResult<ForkAdminAssessmentQuestionResponses, unknown, ThrowOnError> => (options.client ?? client).post<ForkAdminAssessmentQuestionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/assessment_questions/{id}/fork',
    ...options
});

/**
 * list assessment_statistics
 *
 * Get assessment statistics list
 */
export const getAdminAssessmentStatistics = <ThrowOnError extends boolean = false>(options?: Options<GetAdminAssessmentStatisticsData, ThrowOnError>): RequestResult<GetAdminAssessmentStatisticsResponses, GetAdminAssessmentStatisticsErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminAssessmentStatisticsResponses, GetAdminAssessmentStatisticsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/assessment_statistics',
    ...options
});

/**
 * list init data
 *
 * Get admin init data
 */
export const getAdminInitData = <ThrowOnError extends boolean = false>(options?: Options<GetAdminInitDataData, ThrowOnError>): RequestResult<GetAdminInitDataResponses, GetAdminInitDataErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminInitDataResponses, GetAdminInitDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/base/init_data',
    ...options
});

/**
 * list comments
 *
 * Get comments list
 */
export const getAdminComments = <ThrowOnError extends boolean = false>(options?: Options<GetAdminCommentsData, ThrowOnError>): RequestResult<GetAdminCommentsResponses, GetAdminCommentsErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminCommentsResponses, GetAdminCommentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/comments',
    ...options
});

/**
 * create admin comment
 *
 * Create admin comment
 */
export const createAdminComment = <ThrowOnError extends boolean = false>(options?: Options<CreateAdminCommentData, ThrowOnError>): RequestResult<CreateAdminCommentResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CreateAdminCommentResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/comments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * delete Comment
 *
 * Delete Comment
 */
export const deleteAdminComment = <ThrowOnError extends boolean = false>(options: Options<DeleteAdminCommentData, ThrowOnError>): RequestResult<DeleteAdminCommentResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteAdminCommentResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/comments/{id}',
    ...options
});

/**
 * show comment
 *
 * Show comment
 */
export const getAdminComment = <ThrowOnError extends boolean = false>(options: Options<GetAdminCommentData, ThrowOnError>): RequestResult<GetAdminCommentResponses, GetAdminCommentErrors, ThrowOnError> => (options.client ?? client).get<GetAdminCommentResponses, GetAdminCommentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/comments/{id}',
    ...options
});

/**
 * list documents for a document set
 *
 * Get documents belonging to a document set
 */
export const getDocumentsForDocumentSet = <ThrowOnError extends boolean = false>(options?: Options<GetDocumentsForDocumentSetData, ThrowOnError>): RequestResult<GetDocumentsForDocumentSetResponses, GetDocumentsForDocumentSetErrors, ThrowOnError> => (options?.client ?? client).get<GetDocumentsForDocumentSetResponses, GetDocumentsForDocumentSetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/document_sets/get_documents',
    ...options
});

/**
 * list documents
 *
 * Get documents list
 */
export const getAdminDocuments = <ThrowOnError extends boolean = false>(options?: Options<GetAdminDocumentsData, ThrowOnError>): RequestResult<GetAdminDocumentsResponses, GetAdminDocumentsErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminDocumentsResponses, GetAdminDocumentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/documents',
    ...options
});

/**
 * show document
 *
 * Show document
 */
export const getAdminDocument = <ThrowOnError extends boolean = false>(options: Options<GetAdminDocumentData, ThrowOnError>): RequestResult<GetAdminDocumentResponses, GetAdminDocumentErrors, ThrowOnError> => (options.client ?? client).get<GetAdminDocumentResponses, GetAdminDocumentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/documents/{id}',
    ...options
});

/**
 * list groups
 *
 * Get groups list
 */
export const getAdminGroups = <ThrowOnError extends boolean = false>(options?: Options<GetAdminGroupsData, ThrowOnError>): RequestResult<GetAdminGroupsResponses, GetAdminGroupsErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminGroupsResponses, GetAdminGroupsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/groups',
    ...options
});

/**
 * show group
 *
 * Show group
 */
export const getAdminGroup = <ThrowOnError extends boolean = false>(options: Options<GetAdminGroupData, ThrowOnError>): RequestResult<GetAdminGroupResponses, GetAdminGroupErrors, ThrowOnError> => (options.client ?? client).get<GetAdminGroupResponses, GetAdminGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/groups/{id}',
    ...options
});

/**
 * list learning_objectives
 *
 * Get learning_objectives list
 */
export const getAdminLearningObjectives = <ThrowOnError extends boolean = false>(options?: Options<GetAdminLearningObjectivesData, ThrowOnError>): RequestResult<GetAdminLearningObjectivesResponses, GetAdminLearningObjectivesErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminLearningObjectivesResponses, GetAdminLearningObjectivesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/learning_objectives',
    ...options
});

/**
 * show learning_objective
 *
 * Show learning_objective
 */
export const getAdminLearningObjective = <ThrowOnError extends boolean = false>(options: Options<GetAdminLearningObjectiveData, ThrowOnError>): RequestResult<GetAdminLearningObjectiveResponses, GetAdminLearningObjectiveErrors, ThrowOnError> => (options.client ?? client).get<GetAdminLearningObjectiveResponses, GetAdminLearningObjectiveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/learning_objectives/{id}',
    ...options
});

/**
 * list projects
 *
 * Get projects list
 */
export const getAdminProjects = <ThrowOnError extends boolean = false>(options?: Options<GetAdminProjectsData, ThrowOnError>): RequestResult<GetAdminProjectsResponses, GetAdminProjectsErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminProjectsResponses, GetAdminProjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/project_projects',
    ...options
});

/**
 * list quiz_item_responses
 *
 * Get quiz_item_responses list
 */
export const getAdminQuizItemResponses = <ThrowOnError extends boolean = false>(options?: Options<GetAdminQuizItemResponsesData, ThrowOnError>): RequestResult<GetAdminQuizItemResponsesResponses, GetAdminQuizItemResponsesErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminQuizItemResponsesResponses, GetAdminQuizItemResponsesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/quiz_item_responses',
    ...options
});

/**
 * show quiz_item_response
 *
 * Show quiz_item_response
 */
export const getAdminQuizItemResponse = <ThrowOnError extends boolean = false>(options: Options<GetAdminQuizItemResponseData, ThrowOnError>): RequestResult<GetAdminQuizItemResponseResponses, GetAdminQuizItemResponseErrors, ThrowOnError> => (options.client ?? client).get<GetAdminQuizItemResponseResponses, GetAdminQuizItemResponseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/quiz_item_responses/{id}',
    ...options
});

/**
 * list quiz_items
 *
 * Get quiz_items list
 */
export const getAdminQuizItems = <ThrowOnError extends boolean = false>(options?: Options<GetAdminQuizItemsData, ThrowOnError>): RequestResult<GetAdminQuizItemsResponses, GetAdminQuizItemsErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminQuizItemsResponses, GetAdminQuizItemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/quiz_items',
    ...options
});

/**
 * show quiz_item
 *
 * Show quiz_item
 */
export const getAdminQuizItem = <ThrowOnError extends boolean = false>(options: Options<GetAdminQuizItemData, ThrowOnError>): RequestResult<GetAdminQuizItemResponses, GetAdminQuizItemErrors, ThrowOnError> => (options.client ?? client).get<GetAdminQuizItemResponses, GetAdminQuizItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/quiz_items/{id}',
    ...options
});

/**
 * list quizzes
 *
 * Get quizzes list
 */
export const getAdminQuizzes = <ThrowOnError extends boolean = false>(options?: Options<GetAdminQuizzesData, ThrowOnError>): RequestResult<GetAdminQuizzesResponses, GetAdminQuizzesErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminQuizzesResponses, GetAdminQuizzesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/quizzes',
    ...options
});

/**
 * show quiz
 *
 * Show quiz
 */
export const getAdminQuiz = <ThrowOnError extends boolean = false>(options: Options<GetAdminQuizData, ThrowOnError>): RequestResult<GetAdminQuizResponses, GetAdminQuizErrors, ThrowOnError> => (options.client ?? client).get<GetAdminQuizResponses, GetAdminQuizErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/quizzes/{id}',
    ...options
});

/**
 * list reusable_objects
 *
 * Get reusable_objects list
 */
export const getAdminReusableObjects = <ThrowOnError extends boolean = false>(options?: Options<GetAdminReusableObjectsData, ThrowOnError>): RequestResult<GetAdminReusableObjectsResponses, GetAdminReusableObjectsErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminReusableObjectsResponses, GetAdminReusableObjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/reusable_objects',
    ...options
});

/**
 * show reusable_object
 *
 * Show reusable_object
 */
export const getAdminReusableObject = <ThrowOnError extends boolean = false>(options: Options<GetAdminReusableObjectData, ThrowOnError>): RequestResult<GetAdminReusableObjectResponses, GetAdminReusableObjectErrors, ThrowOnError> => (options.client ?? client).get<GetAdminReusableObjectResponses, GetAdminReusableObjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/reusable_objects/{id}',
    ...options
});

/**
 * list saq_responses
 *
 * Get saq_responses list
 */
export const getAdminSaqResponses = <ThrowOnError extends boolean = false>(options?: Options<GetAdminSaqResponsesData, ThrowOnError>): RequestResult<GetAdminSaqResponsesResponses, GetAdminSaqResponsesErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminSaqResponsesResponses, GetAdminSaqResponsesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/saq_responses',
    ...options
});

/**
 * show saq_response
 *
 * Show saq_response
 */
export const getAdminSaqResponse = <ThrowOnError extends boolean = false>(options: Options<GetAdminSaqResponseData, ThrowOnError>): RequestResult<GetAdminSaqResponseResponses, GetAdminSaqResponseErrors, ThrowOnError> => (options.client ?? client).get<GetAdminSaqResponseResponses, GetAdminSaqResponseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/saq_responses/{id}',
    ...options
});

/**
 * list users
 *
 * Get users list
 */
export const getAdminUsers = <ThrowOnError extends boolean = false>(options?: Options<GetAdminUsersData, ThrowOnError>): RequestResult<GetAdminUsersResponses, GetAdminUsersErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminUsersResponses, GetAdminUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users',
    ...options
});

/**
 * show user
 *
 * Show user
 */
export const getAdminUser = <ThrowOnError extends boolean = false>(options: Options<GetAdminUserData, ThrowOnError>): RequestResult<GetAdminUserResponses, GetAdminUserErrors, ThrowOnError> => (options.client ?? client).get<GetAdminUserResponses, GetAdminUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users/{id}',
    ...options
});

/**
 * list versions
 *
 * Get versions list
 */
export const getAdminVersions = <ThrowOnError extends boolean = false>(options?: Options<GetAdminVersionsData, ThrowOnError>): RequestResult<GetAdminVersionsResponses, GetAdminVersionsErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminVersionsResponses, GetAdminVersionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/versions',
    ...options
});

/**
 * show user
 *
 * User details
 */
export const getCommonUser = <ThrowOnError extends boolean = false>(options?: Options<GetCommonUserData, ThrowOnError>): RequestResult<GetCommonUserResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCommonUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/common/user',
    ...options
});

/**
 * Retrieves the list of cards
 */
export const getApiV1GroupsByGroupIdCards = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdCardsData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdCardsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdCardsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/cards',
    ...options
});

/**
 * Toggles a card's disabled state
 */
export const patchApiV1GroupsByGroupIdCardsToggle = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1GroupsByGroupIdCardsToggleData, ThrowOnError>): RequestResult<PatchApiV1GroupsByGroupIdCardsToggleResponses, PatchApiV1GroupsByGroupIdCardsToggleErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1GroupsByGroupIdCardsToggleResponses, PatchApiV1GroupsByGroupIdCardsToggleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/cards/toggle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieves student_progress_summary
 */
export const getApiV1GroupsByGroupIdDashboardsStudentProgressSummary = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdDashboardsStudentProgressSummaryData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdDashboardsStudentProgressSummaryResponses, GetApiV1GroupsByGroupIdDashboardsStudentProgressSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdDashboardsStudentProgressSummaryResponses, GetApiV1GroupsByGroupIdDashboardsStudentProgressSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/dashboards/student_progress_summary',
    ...options
});

/**
 * Retrieves student_case_learning_time
 */
export const getApiV1GroupsByGroupIdDashboardsStudentCaseLearningTime = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdDashboardsStudentCaseLearningTimeData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdDashboardsStudentCaseLearningTimeResponses, GetApiV1GroupsByGroupIdDashboardsStudentCaseLearningTimeErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdDashboardsStudentCaseLearningTimeResponses, GetApiV1GroupsByGroupIdDashboardsStudentCaseLearningTimeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/dashboards/student_case_learning_time',
    ...options
});

/**
 * Retrieves student_performance_summary
 */
export const getApiV1GroupsByGroupIdDashboardsStudentPerformanceSummary = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdDashboardsStudentPerformanceSummaryData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdDashboardsStudentPerformanceSummaryResponses, GetApiV1GroupsByGroupIdDashboardsStudentPerformanceSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdDashboardsStudentPerformanceSummaryResponses, GetApiV1GroupsByGroupIdDashboardsStudentPerformanceSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/dashboards/student_performance_summary',
    ...options
});

/**
 * Retrieves student_calibrate_summary
 */
export const getApiV1GroupsByGroupIdDashboardsStudentCalibrateSummary = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdDashboardsStudentCalibrateSummaryData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdDashboardsStudentCalibrateSummaryResponses, GetApiV1GroupsByGroupIdDashboardsStudentCalibrateSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdDashboardsStudentCalibrateSummaryResponses, GetApiV1GroupsByGroupIdDashboardsStudentCalibrateSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/dashboards/student_calibrate_summary',
    ...options
});

/**
 * Retrieves student_completed_work
 */
export const getApiV1GroupsByGroupIdDashboardsStudentCompletedWork = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdDashboardsStudentCompletedWorkData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdDashboardsStudentCompletedWorkResponses, GetApiV1GroupsByGroupIdDashboardsStudentCompletedWorkErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdDashboardsStudentCompletedWorkResponses, GetApiV1GroupsByGroupIdDashboardsStudentCompletedWorkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/dashboards/student_completed_work',
    ...options
});

/**
 * Retrieves student_completed_available_cases
 */
export const getApiV1GroupsByGroupIdDashboardsStudentCompletedAvailableCases = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdDashboardsStudentCompletedAvailableCasesData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdDashboardsStudentCompletedAvailableCasesResponses, GetApiV1GroupsByGroupIdDashboardsStudentCompletedAvailableCasesErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdDashboardsStudentCompletedAvailableCasesResponses, GetApiV1GroupsByGroupIdDashboardsStudentCompletedAvailableCasesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/dashboards/student_completed_available_cases',
    ...options
});

/**
 * Retrieves student_completed_available_cases
 */
export const getApiV1GroupsByGroupIdDashboardsStudentContentSummary = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdDashboardsStudentContentSummaryData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdDashboardsStudentContentSummaryResponses, GetApiV1GroupsByGroupIdDashboardsStudentContentSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdDashboardsStudentContentSummaryResponses, GetApiV1GroupsByGroupIdDashboardsStudentContentSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/dashboards/student_content_summary',
    ...options
});

/**
 * Requests subscriber access
 */
export const postApiV1GroupsByGroupIdDashboardsSubscriberAccessRequest = <ThrowOnError extends boolean = false>(options: Options<PostApiV1GroupsByGroupIdDashboardsSubscriberAccessRequestData, ThrowOnError>): RequestResult<PostApiV1GroupsByGroupIdDashboardsSubscriberAccessRequestResponses, PostApiV1GroupsByGroupIdDashboardsSubscriberAccessRequestErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1GroupsByGroupIdDashboardsSubscriberAccessRequestResponses, PostApiV1GroupsByGroupIdDashboardsSubscriberAccessRequestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/dashboards/subscriber_access_request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieves documents related to a document set
 */
export const getApiV1GroupsByGroupIdDocumentSetsByDocumentSetIdDocuments = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdDocumentSetsByDocumentSetIdDocumentsData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdDocumentSetsByDocumentSetIdDocumentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdDocumentSetsByDocumentSetIdDocumentsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/document_sets/{document_set_id}/documents',
    ...options
});

/**
 * Retrieves document sets nested under a parent document set
 */
export const getApiV1GroupsByGroupIdDocumentSetsByParentDocumentSetIdDocumentSets = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdDocumentSetsByParentDocumentSetIdDocumentSetsData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdDocumentSetsByParentDocumentSetIdDocumentSetsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdDocumentSetsByParentDocumentSetIdDocumentSetsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/document_sets/{parent_document_set_id}/document_sets',
    ...options
});

/**
 * Track events
 */
export const getApiV1Events = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1EventsData, ThrowOnError>): RequestResult<GetApiV1EventsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1EventsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/events',
    ...options
});

/**
 * Show Group Role definition user details
 */
export const getApiV1GroupsByGroupIdGroupRoleDefinitionUsersById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/group_role_definition_users/{id}',
    ...options
});

/**
 * Update Group Role definition user details
 */
export const putApiV1GroupsByGroupIdGroupRoleDefinitionUsersById = <ThrowOnError extends boolean = false>(options: Options<PutApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdData, ThrowOnError>): RequestResult<PutApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdResponses, PutApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdResponses, PutApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/group_role_definition_users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Index grops
 */
export const getApiV1Groups = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1GroupsData, ThrowOnError>): RequestResult<GetApiV1GroupsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1GroupsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups',
    ...options
});

/**
 * Show Group details
 */
export const getApiV1GroupsById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByIdData, ThrowOnError>): RequestResult<GetApiV1GroupsByIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{id}',
    ...options
});

/**
 * List custom documents for group
 */
export const getApiV1GroupsByIdCustomDocuments = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByIdCustomDocumentsData, ThrowOnError>): RequestResult<GetApiV1GroupsByIdCustomDocumentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByIdCustomDocumentsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{id}/custom_documents',
    ...options
});

/**
 * Updated Groups
 */
export const getApiV1Updates = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1UpdatesData, ThrowOnError>): RequestResult<GetApiV1UpdatesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1UpdatesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/updates',
    ...options
});

/**
 * Join Open Group
 *
 * @deprecated
 */
export const getApiV1GroupsByIdJoinOpenGroups = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1GroupsByIdJoinOpenGroupsData, ThrowOnError>): RequestResult<GetApiV1GroupsByIdJoinOpenGroupsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1GroupsByIdJoinOpenGroupsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{id}/join_open_groups',
    ...options
});

/**
 * Index public grops
 *
 * @deprecated
 */
export const getApiV1PublicGroups = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1PublicGroupsData, ThrowOnError>): RequestResult<GetApiV1PublicGroupsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1PublicGroupsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public_groups',
    ...options
});

/**
 * List grops
 *
 * @deprecated
 */
export const postApiV1GroupsMobileJson = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1GroupsMobileJsonData, ThrowOnError>): RequestResult<PostApiV1GroupsMobileJsonResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostApiV1GroupsMobileJsonResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/mobile_json',
    ...options
});

/**
 * List quiz item responses
 */
export const getApiV1GroupsByGroupIdQuizItemResponses = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdQuizItemResponsesData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdQuizItemResponsesResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdQuizItemResponsesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/quiz_item_responses',
    ...options
});

/**
 * Show quiz item response details
 */
export const getApiV1GroupsByGroupIdQuizItemResponsesById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdQuizItemResponsesByIdData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdQuizItemResponsesByIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdQuizItemResponsesByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/quiz_item_responses/{id}',
    ...options
});

/**
 * Update quiz item response
 */
export const putApiV1GroupsByGroupIdQuizItemResponsesById = <ThrowOnError extends boolean = false>(options: Options<PutApiV1GroupsByGroupIdQuizItemResponsesByIdData, ThrowOnError>): RequestResult<PutApiV1GroupsByGroupIdQuizItemResponsesByIdResponses, unknown, ThrowOnError> => (options.client ?? client).put<PutApiV1GroupsByGroupIdQuizItemResponsesByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/quiz_item_responses/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk Update quiz item responses
 */
export const putApiV1GroupsByGroupIdQuizItemResponsesBulkUpdate = <ThrowOnError extends boolean = false>(options: Options<PutApiV1GroupsByGroupIdQuizItemResponsesBulkUpdateData, ThrowOnError>): RequestResult<PutApiV1GroupsByGroupIdQuizItemResponsesBulkUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<PutApiV1GroupsByGroupIdQuizItemResponsesBulkUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/quiz_item_responses/bulk_update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset quiz item response
 */
export const patchApiV1GroupsByGroupIdQuizItemResponsesByIdReset = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1GroupsByGroupIdQuizItemResponsesByIdResetData, ThrowOnError>): RequestResult<PatchApiV1GroupsByGroupIdQuizItemResponsesByIdResetResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchApiV1GroupsByGroupIdQuizItemResponsesByIdResetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/quiz_item_responses/{id}/reset',
    ...options
});

/**
 * List quizzes
 */
export const getApiV1GroupsByGroupIdQuizzes = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdQuizzesData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdQuizzesResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdQuizzesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/quizzes',
    ...options
});

/**
 * Create new quiz
 */
export const postApiV1GroupsByGroupIdQuizzes = <ThrowOnError extends boolean = false>(options: Options<PostApiV1GroupsByGroupIdQuizzesData, ThrowOnError>): RequestResult<PostApiV1GroupsByGroupIdQuizzesResponses, PostApiV1GroupsByGroupIdQuizzesErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1GroupsByGroupIdQuizzesResponses, PostApiV1GroupsByGroupIdQuizzesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/quizzes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Show quiz details
 */
export const getApiV1GroupsByGroupIdQuizzesById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdQuizzesByIdData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdQuizzesByIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdQuizzesByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/quizzes/{id}',
    ...options
});

/**
 * Get Form data for quiz creation
 */
export const getApiV1GroupsByGroupIdQuizzesNew = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdQuizzesNewData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdQuizzesNewResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdQuizzesNewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/quizzes/new',
    ...options
});

/**
 * Get number of available questions
 */
export const postApiV1GroupsByGroupIdQuizzesNumberOfItems = <ThrowOnError extends boolean = false>(options: Options<PostApiV1GroupsByGroupIdQuizzesNumberOfItemsData, ThrowOnError>): RequestResult<PostApiV1GroupsByGroupIdQuizzesNumberOfItemsResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostApiV1GroupsByGroupIdQuizzesNumberOfItemsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/quizzes/number_of_items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset quiz
 */
export const patchApiV1GroupsByGroupIdQuizzesByIdReset = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1GroupsByGroupIdQuizzesByIdResetData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> => (options.client ?? client).patch<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/quizzes/{id}/reset',
    ...options
});

/**
 * List saq responses
 */
export const getApiV1GroupsByGroupIdSaqResponses = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdSaqResponsesData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdSaqResponsesResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdSaqResponsesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/saq_responses',
    ...options
});

/**
 * Show saq responses
 */
export const getApiV1GroupsByGroupIdSaqResponsesById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdSaqResponsesByIdData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdSaqResponsesByIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdSaqResponsesByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/saq_responses/{id}',
    ...options
});

/**
 * Toggle saq response
 */
export const patchApiV1GroupsByGroupIdSaqResponsesByIdToggleFlag = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1GroupsByGroupIdSaqResponsesByIdToggleFlagData, ThrowOnError>): RequestResult<PatchApiV1GroupsByGroupIdSaqResponsesByIdToggleFlagResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchApiV1GroupsByGroupIdSaqResponsesByIdToggleFlagResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/saq_responses/{id}/toggle_flag',
    ...options
});

/**
 * Create quiz for given saq responses
 */
export const postApiV1GroupsByGroupIdSaqResponsesCreateQuiz = <ThrowOnError extends boolean = false>(options: Options<PostApiV1GroupsByGroupIdSaqResponsesCreateQuizData, ThrowOnError>): RequestResult<PostApiV1GroupsByGroupIdSaqResponsesCreateQuizResponses, PostApiV1GroupsByGroupIdSaqResponsesCreateQuizErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1GroupsByGroupIdSaqResponsesCreateQuizResponses, PostApiV1GroupsByGroupIdSaqResponsesCreateQuizErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/saq_responses/create_quiz',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset saq response
 */
export const postApiV1GroupsByGroupIdSaqResponsesByIdReset = <ThrowOnError extends boolean = false>(options: Options<PostApiV1GroupsByGroupIdSaqResponsesByIdResetData, ThrowOnError>): RequestResult<PostApiV1GroupsByGroupIdSaqResponsesByIdResetResponses, PostApiV1GroupsByGroupIdSaqResponsesByIdResetErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1GroupsByGroupIdSaqResponsesByIdResetResponses, PostApiV1GroupsByGroupIdSaqResponsesByIdResetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/saq_responses/{id}/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generates auth token
 */
export const postApiV1UsersSignIn = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1UsersSignInData, ThrowOnError>): RequestResult<PostApiV1UsersSignInResponses, PostApiV1UsersSignInErrors, ThrowOnError> => (options?.client ?? client).post<PostApiV1UsersSignInResponses, PostApiV1UsersSignInErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/sign_in',
    ...options
});

/**
 * Destroys auth token
 */
export const deleteApiV1UsersSignOut = <ThrowOnError extends boolean = false>(options?: Options<DeleteApiV1UsersSignOutData, ThrowOnError>): RequestResult<DeleteApiV1UsersSignOutResponses, DeleteApiV1UsersSignOutErrors, ThrowOnError> => (options?.client ?? client).delete<DeleteApiV1UsersSignOutResponses, DeleteApiV1UsersSignOutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/sign_out',
    ...options
});

/**
 * List todo items
 */
export const getApiV1GroupsByGroupIdTodoItems = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdTodoItemsData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdTodoItemsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdTodoItemsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/todo_items',
    ...options
});

/**
 * Creates a TodoItem
 */
export const postApiV1GroupsByGroupIdTodoItems = <ThrowOnError extends boolean = false>(options: Options<PostApiV1GroupsByGroupIdTodoItemsData, ThrowOnError>): RequestResult<PostApiV1GroupsByGroupIdTodoItemsResponses, PostApiV1GroupsByGroupIdTodoItemsErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1GroupsByGroupIdTodoItemsResponses, PostApiV1GroupsByGroupIdTodoItemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/todo_items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a TodoItem
 */
export const deleteApiV1GroupsByGroupIdTodoItemsByTodoItemId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1GroupsByGroupIdTodoItemsByTodoItemIdData, ThrowOnError>): RequestResult<DeleteApiV1GroupsByGroupIdTodoItemsByTodoItemIdResponses, DeleteApiV1GroupsByGroupIdTodoItemsByTodoItemIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1GroupsByGroupIdTodoItemsByTodoItemIdResponses, DeleteApiV1GroupsByGroupIdTodoItemsByTodoItemIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/todo_items/{todo_item_id}',
    ...options
});

/**
 * Updates a TodoItem
 */
export const patchApiV1GroupsByGroupIdTodoItemsByTodoItemId = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdData, ThrowOnError>): RequestResult<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResponses, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResponses, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/todo_items/{todo_item_id}',
    ...options
});

/**
 * Reset case
 */
export const patchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResetCase = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResetCaseData, ThrowOnError>): RequestResult<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResetCaseResponses, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResetCaseErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResetCaseResponses, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResetCaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/todo_items/{todo_item_id}/reset_case',
    ...options
});

/**
 * Bulk create or update
 */
export const postApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkCreateOrUpdate = <ThrowOnError extends boolean = false>(options: Options<PostApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkCreateOrUpdateData, ThrowOnError>): RequestResult<PostApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkCreateOrUpdateResponses, PostApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkCreateOrUpdateErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkCreateOrUpdateResponses, PostApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkCreateOrUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/todo_items/{todo_item_id}/bulk_create_or_update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk Reset
 */
export const patchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkReset = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkResetData, ThrowOnError>): RequestResult<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkResetResponses, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkResetErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkResetResponses, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkResetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/todo_items/{todo_item_id}/bulk_reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk Move
 */
export const patchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkMove = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkMoveData, ThrowOnError>): RequestResult<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkMoveResponses, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkMoveErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkMoveResponses, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkMoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/todo_items/{todo_item_id}/bulk_move',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Creates a new todo list
 */
export const postApiV1GroupsByGroupIdTodoLists = <ThrowOnError extends boolean = false>(options: Options<PostApiV1GroupsByGroupIdTodoListsData, ThrowOnError>): RequestResult<PostApiV1GroupsByGroupIdTodoListsResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostApiV1GroupsByGroupIdTodoListsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/todo_lists',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletes a todo list
 */
export const deleteApiV1GroupsByGroupIdTodoListsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1GroupsByGroupIdTodoListsByIdData, ThrowOnError>): RequestResult<DeleteApiV1GroupsByGroupIdTodoListsByIdResponses, DeleteApiV1GroupsByGroupIdTodoListsByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1GroupsByGroupIdTodoListsByIdResponses, DeleteApiV1GroupsByGroupIdTodoListsByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/todo_lists/{id}',
    ...options
});

/**
 * Updates the user password
 */
export const patchApiV1UsersById = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1UsersByIdData, ThrowOnError>): RequestResult<PatchApiV1UsersByIdResponses, PatchApiV1UsersByIdErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1UsersByIdResponses, PatchApiV1UsersByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Show Variant details
 */
export const getApiV1GroupsByGroupIdVariantsById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1GroupsByGroupIdVariantsByIdData, ThrowOnError>): RequestResult<GetApiV1GroupsByGroupIdVariantsByIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetApiV1GroupsByGroupIdVariantsByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/groups/{group_id}/variants/{id}',
    ...options
});

/**
 * Retrieves a list of documents
 */
export const getApiV3GroupsByGroupIdDocuments = <ThrowOnError extends boolean = false>(options: Options<GetApiV3GroupsByGroupIdDocumentsData, ThrowOnError>): RequestResult<GetApiV3GroupsByGroupIdDocumentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetApiV3GroupsByGroupIdDocumentsResponses, unknown, ThrowOnError>({ url: '/api/v3/groups/{group_id}/documents', ...options });

/**
 * Retrieves a document
 */
export const getApiV3GroupsByGroupIdDocumentsById = <ThrowOnError extends boolean = false>(options: Options<GetApiV3GroupsByGroupIdDocumentsByIdData, ThrowOnError>): RequestResult<GetApiV3GroupsByGroupIdDocumentsByIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetApiV3GroupsByGroupIdDocumentsByIdResponses, unknown, ThrowOnError>({ url: '/api/v3/groups/{group_id}/documents/{id}', ...options });

/**
 * Creates or updates todo items
 */
export const getApiV3GroupsByGroupIdDocumentsByIdCreateOrUpdateTodoItems = <ThrowOnError extends boolean = false>(options: Options<GetApiV3GroupsByGroupIdDocumentsByIdCreateOrUpdateTodoItemsData, ThrowOnError>): RequestResult<GetApiV3GroupsByGroupIdDocumentsByIdCreateOrUpdateTodoItemsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetApiV3GroupsByGroupIdDocumentsByIdCreateOrUpdateTodoItemsResponses, unknown, ThrowOnError>({ url: '/api/v3/groups/{group_id}/documents/{id}/create_or_update_todo_items', ...options });

/**
 * Creates or starts a quiz
 */
export const postApiV3GroupsByGroupIdDocumentsByIdCreateOrStartQuiz = <ThrowOnError extends boolean = false>(options: Options<PostApiV3GroupsByGroupIdDocumentsByIdCreateOrStartQuizData, ThrowOnError>): RequestResult<PostApiV3GroupsByGroupIdDocumentsByIdCreateOrStartQuizResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostApiV3GroupsByGroupIdDocumentsByIdCreateOrStartQuizResponses, unknown, ThrowOnError>({ url: '/api/v3/groups/{group_id}/documents/{id}/create_or_start_quiz', ...options });
